import React, { useState } from 'react'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import SimVerification from './Components/SimVerification'
import PlanListing from './Components/PlanListing'
import ChooseNumber from './Components/ChooseNumber'
import CustomerDetails from './Components/CustomerDetails'
import Summary from './Components/Summary'
import Payment from './Components/Payment'
import VerifyUsername from './Components/VerifyUsername'
import IdValidation from './Components/IdValidation'
import CreateAccount from './Components/CreateAccount'
import StaffDetails from './Components/StaffDetails'



function PremiumNumbers() {
  const [step, setStep] = useState(1);
  const[commonSession,setcommonSession]=useState("")
  const[planData,setPlanData]=useState([])

  const [planDetails,setplanDetails] = useState([]);
  const [selectedPlanData,setSelectedPlanData] = useState([]);

  const [activationSuccessMsg, setActivationSuccessMsg] = useState("")
  const [activationSuccessData,setActivationSuccessData] = useState([])
  const [validationStatus,setValidationStatus]=useState(false)


  const PlanSelection = (data) => {
    setSelectedPlanData(data);
  };


  const [dvsdetails,setDvsdetails] = useState([]);
  const dvsEntries = (data) => {
    setDvsdetails(data);
  };


  const [retailerDetails,setretailerDetails] = useState(null);
  const getRetailerData = (data) => {
    setretailerDetails(data);
  };



  const [userAccountData,setUserAccountData] = useState([]);
  const accountData = (data) => {
    setUserAccountData(data);
  };

  const clearDvs = () => {
    setDvsdetails([]);
  };



  const [prevFormData,setPrevFormData] = useState({
    "chooseNumber" :{},
    "telsimSim":{},
    "mobileNumber":{},
    "selectPlan":{},
     "SetupYourProfile":{},
  })


const[userEmail,setUserEmail]=useState("")















  const nextStep = () =>{setStep((prevStep) => prevStep + 1)};
  const prevStep = () => setStep((prevStep) => prevStep - 1);
  const commonProps = { nextStep, prevStep, step, setStep,prevFormData,setPrevFormData,commonSession,setcommonSession};


















  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />

        {step === 1 && <ChooseNumber {...commonProps} />}
        {step === 2 && <SimVerification {...commonProps} getPlanData={setplanDetails} handleRetailer={getRetailerData} />}
        {step === 3 && <PlanListing {...commonProps} planDetails={planDetails} handlePlanSelection={PlanSelection} />}
        {step === 4 && <VerifyUsername {...commonProps} getUserEmail={setUserEmail} getValidationStatus={setValidationStatus}  />}
        {step === 5 && < IdValidation {...commonProps} handleDvsEntry={dvsEntries} dvs_Details={dvsdetails}  />}
        {step === 6 && <CreateAccount  {...commonProps} retailerDetails={retailerDetails}  userEmail={userEmail}/>}
        {step === 7 && <StaffDetails  {...commonProps}  handleAccount={accountData} userEmail={userEmail} validationStatus={validationStatus}/>}
        {step === 8 && <Payment  {...commonProps} userAccountData={userAccountData} selectedPlanData={selectedPlanData} setActivationSuccessMsg={setActivationSuccessMsg} setActivationSuccessData={setActivationSuccessData} planDetails={planDetails} dvsdetails={dvsdetails}/>}
        {step === 9 && <Summary  {...commonProps}  userAccountData={userAccountData} activationSuccessMsg={activationSuccessMsg} selectedPlanData={selectedPlanData} activationSuccessData={activationSuccessData} planDetails={planDetails} clearDvsEntry={clearDvs}/>}


      </DashboardLayout>
    </div>
  )
}

export default  PremiumNumbers